import { lazy } from 'react';
const tuneSVG = './assets/icons/tune.svg';

const EntryPoint = lazy(() => import('./components/EntryPoint/EntryPoint'));
const RenewalConfigsLoader = lazy(() => import('./components/RenewalConfigsLoader/RenewalConfigsLoader.container'));

export const defaultPath = '/renewalConfigs';

export const innerRoutes = [
    {
        path: `${defaultPath}/`,
        Component: RenewalConfigsLoader,
        exact: true,
        icon: tuneSVG,
        title: { key: '', plural: false },
        subTitle: { key: '', plural: false },
    }
];

const RenewalConfigs = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: tuneSVG,
    title: { key: 'Configuración de renovaciones', plural: false },
    subTitle: { key: 'Parámetros de renovación por compañía', plural: false },
    innerRoutes,
    pathChilds: innerRoutes.map(r => r.path),
};

export default RenewalConfigs;
